import { O } from '../../../features/ui'
import { QueryOptions } from '../../../services/dynamo'
import { TableName } from '../../../tables'
import { ListResponse, useLoaders } from '../../common'
import { useSystemStateHooks } from '../../system'
import { Delivery } from '../state/types'

export const useDeliveryLoaders = () => {
    const systemHooks = useSystemStateHooks()

    const loaders = useLoaders()

    return (companyId = systemHooks.companyId) => {
        const loadDeliveriesBatch = async (
            options?: QueryOptions,
            optimized = true
        ) => {
            const { loadMultiple } = loaders(companyId)
            return loadMultiple(TableName.DELIVERIES2, options, optimized) as Promise<ListResponse<Delivery>>
        }

        const loadDelivery = (
            id: string,
            optimized = true
        ) => {
            const { load } = loaders(companyId)
            return load(TableName.DELIVERIES2, id, !optimized) as Promise<O<Delivery>>
        }

        const loadDeliveries = (
            ids: string[],
            dbRequest = false
        ) => {
            const { loadByIds } = loaders(companyId)
            return loadByIds(TableName.DELIVERIES2, ids, dbRequest) as Promise<Delivery[]>
        }

        const loadOrderDeliveries = async (deliveryOrderId: string) => {
            const options = {
                valueFilters: [{ prop: 'orderId', value: deliveryOrderId }]
            }
            const response = await loadDeliveriesBatch(options)
            return response.dataTypes as Delivery[]
        }

        const loadOrdersDeliveries = (deliveryOrderIds: string[], dbRequest = false) => {
            const { loadFilteredByList } = loaders(companyId)
            return loadFilteredByList(TableName.DELIVERIES2, dbRequest, 'orderId', deliveryOrderIds) as Promise<Delivery[]>
        }

        const loadOperationDeliveries = async (operationId: string, optimized = true) => {
            const options = {
                valueFilters: [{ prop: 'operationId', value: operationId }]
            }
            const response = await loadDeliveriesBatch(options, optimized)
            return response.dataTypes as Delivery[]
        }

        const loadOperationsDeliveries = (operationIds: string[], dbRequest = false) => {
            const { loadFilteredByList } = loaders(companyId)
            return loadFilteredByList(TableName.DELIVERIES2, dbRequest, 'operationId', operationIds) as Promise<Delivery[]>
        }

        const countDeliveries = (propName: string, propValue: string) => {
            const options = {
                valueFilters: [{
                    value: propValue,
                    prop: propName
                }],
                limit: 1
            }
            const { count2 } = loaders(companyId)
            return count2(TableName.DELIVERIES2, options)
        }

        return {
            loadDeliveriesBatch,
            loadDelivery,
            loadDeliveries,
            loadOrderDeliveries,
            loadOrdersDeliveries,
            loadOperationDeliveries,
            loadOperationsDeliveries,
            countDeliveries
        }
    }
}
